import { trpc } from '@/shared/api/trpc';

// Runs the org initialization. On success, refetch the init status (so the
// trigger disappears once initialized) and the itineraries list (so the new
// demo itinerary shows up).
export const useInitializeOrganization = () => {
  const utils = trpc.useUtils();
  return trpc.organizationInit.initialize.useMutation({
    onSuccess: () => {
      utils.organizationInit.status.invalidate();
      utils.itineraries.invalidate();
    },
  });
};
